module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("CHAPTER 1")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("THE FIRST URBAN CENTURY")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Congested. Creative. Loud. Artistic. Sinful. Busy. High crime. High earnings. Easy anonymity. Easy networking. Hyperactive. Hip. Boisterous. Innovative. Ruthless. Soaring. Intimidating. Invigorating.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The world’s cities are all of the above, and more. You can love the energy of Hong Kong or Rome or Los Angeles, or you can despise their hectic (and expensive) lifestyles. The minute you start to think about ministry in an urban center, a rush of possibilities floods your mind, only to collide a few seconds later with an undertow of complications.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A recent study in India—one of the world’s fastest-growing, fastest- changing societies—asked city dwellers about “the pace of modern life.” Forty-nine percent liked it (more young people than older, understandably), while 37 percent disliked it, and 13 percent couldn’t make up their minds. Those with a college degree and those with high incomes—in other words, the “haves”—were more positive than the less educated and poor. Yet in the same survey, 52 percent (and 62 percent of those with a college degree) said, “Our traditional way of life is getting lost.” More than eight out of ten Indians bemoaned the fact that the rich were getting richer while the poor were getting poorer."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-001",
      "id": "ap_ntf-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All around the world, and especially on the continents of Asia and Africa, urban growth is an unstoppable train. As Ray Bakke, a leading "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("U.S. advocate for city ministry, says to his audiences, “You have an urban future, whether you like it or not.”")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WHAT THE NUMBERS TELL US")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The most recent United Nations numbers say that the global population—currently at 7.2 billion souls—will add another 53 percent by the end of this century, reaching somewhere around 11 billion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-002",
      "id": "ap_ntf-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" More to our point, "), _c('i', [_vm._v("90 percent")]), _vm._v(" of those 11 billion will live in cities.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is hard to remember that only as recently as the year 1800, the urban figure was a mere 3 percent; the other 97 percent lived in rural areas. Now the tables have been completely turned. Thus the 21st century will be the first urban century in human history.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-004"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/FGC_Ch1D_Demography_Urbanization_Fig1_16v1-bw.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The tipping point, statisticians now believe, came around 2007 or 2008, when the world’s urban population outpaced the rural population. Since that point, the urban line only keeps climbing, while the rural line gradually declines.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some may wonder what defines the word "), _c('i', [_vm._v("urban")]), _vm._v(". How big a city does it signify? The U.N. Population Division has set no global metric; it simply collects and reports what the 230-some individual countries consider to be “urban.” In some nations, 50,000 people in a given area is the threshold; in others, lesser figures are used. Regardless, the reality is that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("more and more people on this planet are carrying on their daily lives in the close quarters we all understand to be urban.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And in some individual cities, the swelling size is taking on startling proportions. Pause for a minute to study these Top Ten lists:")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-005"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/FGC_Ch1D_Demography_Urbanization_Fig1_17v1-bw.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Think about those numbers. How big and overwhelming would one city be with 50 million residents (for example, Mumbai or Karachi in 2050)? "), _c('i', [_vm._v("Answer:")]), _vm._v(" Imagine today’s New York City metroplex "), _c('i', [_vm._v("times three.")]), _vm._v(" It boggles the mind. And Lagos, Nigeria, is slated to be even larger by mid-century.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Now notice that by then, all of the top ten will be in Africa (3) and Asia (7). Furthermore, only two of the ten (Shanghai and Tokyo) are set to have a highly developed infrastructure—adequate roads, water systems, electrical supply, mass transit, governmental services; most of the others will be struggling to meet the basic needs of their rapidly growing populations.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Meanwhile, all five of the Western Hemisphere cities on the 2000 list (Mexico City, Sao Paulo, New York, Los Angeles, Buenos Aires) will have dropped off by 2050, while Tokyo will have slid from first place to tenth. Only one city in Europe will have as many as 10 million residents—and that will be Istanbul (which lies only partly on European soil; the rest is across the Bosporus strait in Asia).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To visualize the massive change, compare the following two maps:")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-007"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/FGC_Ch1D_Demography_Urbanization_Map01v1r_bw.jpg"
    }
  })])])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-006"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/FGC_Ch1D_Demography_Urbanization_Map02v1r_bw.jpg"
    }
  })])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WHO ARE ALL THESE PEOPLE?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The urban increases of the 21st century will come from two sources:")]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" New children born to those already living in cities, as birth rates in large parts of the world keep running higher than death rates (for a variety of reasons, not the least of which is better medical care for expectant mothers and the babies they bear). Fewer maternal and newborn deaths is a good thing, of course.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Inflow from those moving into the city in search of (a) jobs, (b) more education for themselves or their children, or (c) safety from war or harassment in their home area—whether that be 50 kilometers away or 5,000.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As a result, most cities are becoming noticeably more cross-cultural. Vancouver on the west coast of Canada now has more Sikhs than anywhere outside the Punjab region of northern India. Their colorful turbans can be seen all throughout the city. San Francisco is 38 percent Asian. London is now only 60 percent “white English”; the rest of Londoners are Asian, black, and of mixed heritage. Brussels, the capital of the European Union, has only 32 percent indigenous Flemish and Walloon French inhabitants; the rest are of foreign origin from across Europe and other continents. A quarter of the city’s population is Muslim.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Tim Svoboda, international urban missions director for Youth with a Mission (YWAM), writes, “In the past, missions was primarily about going over the ocean, through the jungle, across the desert to reach the remote. Today, missions is about crossing the street in the cities where we live.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-003",
      "id": "ap_ntf-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("NO GUARANTEES")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As you might expect, many of the urban newcomers are young adults. They may enroll in a college; they may find employment as factory workers, laborers on construction sites, nurses or other aides in the health care field, clerks in shops, street sellers, or some other job.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("Along the way, they may meet someone they wish to marry. If they are able to establish themselves, their parents or other relatives back home—siblings, cousins, etc.—may follow their trail to the city and attempt to duplicate their success.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But if they cannot gain a foothold in the urban economy, dark consequences await. Desperate young women may be lured (or forced) into the sex trade. Desperate young men may resort to theft and violence in order to get food. International people trafficking has become a major source of criminal revenue. Drugs come into play as a way to numb anxiety. For some, the selling of drugs appears to be the only way to get money. Affordable housing is often hard to find, and the new arrivals may wind up wishing they had never ventured toward the bright lights. But going home again is hardly an option.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All of these social and economic dynamics come into play as we look at the prospects for urban ministry.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("FIRST GLIMPSES")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("My early interest in the urbanized world came not because I was intrigued with cities per se, but rather because of my concern for one country: South Africa. I was moved by such books as Alan Paton’s "), _c('i', [_vm._v("Cry, the Beloved Country")]), _vm._v(" and Trevor Huddleston’s "), _c('i', [_vm._v("Naught for Your Comfort")]), _vm._v(". They vividly described the grimness of the apartheid system, especially in the black urban townships that had sprung up with South Africa’s industrialization during World War II.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Such cities were an alien world to me, of course. My family was relatively well off—my father a doctor in a rural area of Gloucestershire in England. My heart was set on being a research scientist, and so I enrolled at the University of Bristol.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There, everything changed. I became a Christian during my first year of studying chemistry and was well discipled by a godly theological student. He brought me to meet other Christian students of the UCCF (Universities and Colleges Christian Fellowship). One midweek evening, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("Glyndwr Davies of the Dorothea Mission, a South African agency, spoke passionately to our group about its evangelistic and discipling ministry. The slides he showed vividly portrayed the harsh realities and spiritual need (but without the smells!). Immediately I knew deep in my heart that God was in this and was calling me to serve with that agency in Africa.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I completed my degree but turned down offers to go on for a Ph.D. I left for Africa in 1962 as a young man of 24.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Since the colonial powers were granting independence to many countries, this was an extraordinary time of change all across the African continent. Decades of turmoil and wars would soon follow, along with massive urbanization and the explosive rise of indigenous Christianity. In many ways, the Dorothea Mission was a pioneer in the cities; almost all other mission activity was directed to rural and tribal areas.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My introduction to the black townships was dramatic and sudden. I was welcomed at the Johannesburg airport by the mission founder and director, Hans von Staden, a great man for vision and prayer. After shaking my hand and loading my baggage into his car, he said, “I am going to show you something.”")]), _c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-001"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I stared out the window at the densely packed array of shacks made from scrap metal, discarded wood, corrugated iron, asbestos sheeting, and pieces of cardboard, all held together with nails, string, and wire. More than 20,000 people lived here in great squalor on a square mile of land.")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What he had in mind was not Joburg’s towering office buildings or the well-manicured lawns of the jacaranda-lined suburbs. Instead, we drove directly to a black shantytown near the white township of Edenvale. This grim settlement had sprung up a few years earlier to house the black workers who were flooding into the cities seeking a better life. I stared out "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("the window at the densely packed array of shacks made from scrap metal, discarded wood, corrugated iron, asbestos sheeting, and pieces of cardboard, all held together with nails, string, and wire. More than 20,000 people lived here in great squalor on a square mile of land. This time I could not miss the accompanying smell, or the deep sense of hopelessness and pain for these city people amid the mud and the open sewers.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Hans von Staden then shared his heart. “This is what moved me to start the mission back in 1943. Nothing was being done to meet the spiritual needs of these people.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I was overwhelmed. He went on to explain, “The physical needs are so great, but the spiritual needs are the greatest of all. Once these dear people become believers in Christ, their lives are transformed, and the money they have is not used for beer or drugs, but for food and improving their housing and the education of their children.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As we drove away, I felt a mix of burden and panic. "), _c('i', [_vm._v("How can I possibly make a difference? Is this what my working conditions will be for the years ahead?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I plunged into completing my Bible training at the mission Bible college in Pretoria. Due to apartheid’s rules, our African workers had to be trained at another institution on the other side of the city. But we would meet up on weekends for ministry in townships with open-air meetings, house visitation, and tract distribution. Night after night, we saw the message of hope and change break through lives ravaged by violence, drunkenness, and in some cases, the occult.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Soon after my training was completed, I was asked to be the leader of a team. This forced me to come face-to-face with the cruel bureaucracy of the apartheid system. In every township where we sought to erect our evangelistic tent, my African co-workers had to obtain a stamp in their passbooks to permit them to stay there. The officials who granted this were petty white officials who were often deliberately difficult and even rude. In such cases, I went along with my co-workers to ensure they were not unjustly denied.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("Our pattern of ministry in the townships was to preach the gospel in every possible way, with the goal of making young disciples who would be strong enough to stand on their own feet once we left, and where possible, be linked to a good congregation of believers among the many churches now springing up in these urban slums. We would pray in the mornings, house-visit and hold open-air meetings in the afternoons, then conduct nightly evangelistic meetings in the tent. We all participated in the preaching, and most of us became at least quadrilingual (using up to four languages) in the process, and some of my African co-workers could speak six languages!")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What was the fruit? Hundreds of thousands had good exposure to the gospel, and thousands came to the point of decision for Christ. Others struggled to let go of the fear of people or their involvement with witchcraft. But many of these seekers went on to become true disciples and some went into full-time ministry for the Lord.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One such was Stephen Lungu. He was converted in Salisbury (now Harare) in Rhodesia (now Zimbabwe) in 1962 during a dramatic Dorothea evangelistic campaign held in the midst of severe unrest against the white minority government of the time. As a small child, Steve’s parents had had a huge row, and both walked out on the other, effectually abandoning their four children. They had no contact with their children for years, thinking that the other would be caring for them. Steve’s one ambition, as a teenager, was to find and kill his mother. As an angry young man, he became involved in crime and was also in a gang.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One night he carried a petrol bomb as he went with his gang to disrupt the tent meeting. But as he sat looking around, the South African preacher, Shadrach Maloka, told how Christ had found him as an abandoned orphan who had become a "), _c('i', [_vm._v("tsosti")]), _vm._v(" (teenage gangster). Steve was riveted. Toward the end of the meeting he went forward, still carrying the petrol bomb with him, and asked Shadrach, “Can your Jesus help me?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Shadrach led him to Jesus that night, and Steve’s life was changed forever. He went to Bible school and joined the mission in which he served as a worker for the next 18 years. I was his first team leader, and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("he became my main “Timothy” as I sought to prepare all my workers for future leadership.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In fact, he took over the leadership from me in 1977. He was later asked by Michael Cassidy to join African Enterprise, an African evangelistic mission, and eventually he became their global ambassador and CEO—a mighty man of God. His autobiography, "), _c('i', [_vm._v("Out of the Black Shadows,")]), _vm._v(" is still in print today. One of the joys of his faith-filled life was that he was used by God not only to forgive his parents, but also lead them to Jesus.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Back at the beginning, during my Bible school days, I had met another U.K. worker named Jill Amsden. In time, we wished to marry. But the mission required that, in light of the tough working conditions and much travel, all workers should remain single for six years. So we faced a long wait.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Finally, we were wed during our first home leave, and when we returned to Africa, we began our service together evangelizing in the cities and towns of Rhodesia. Those were years of national turmoil, which culminated in the end of white rule in 1979-80. Yet it was also a time of spiritual harvest.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Increasingly my African co-workers took on more and more leadership of the work, so that I was able to give time to compiling the first two editions of "), _c('i', [_vm._v("Operation World")]), _vm._v(" (published in 1972 and 1978). This was a miracle, seeing that we had no suitable libraries, and the postal services with over half the world were cut, due to sanctions imposed on the government of Prime Minister Ian Smith.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("LITTLE HAS CHANGED")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These are not just tales of a long-ago past. The urban poor are with us to this very day and will be on into the future. The terminology may vary by location, from “slums” (India) to “townships” (Africa) to “favelas” (Brazil), but the daily reality is much the same. Later in this book (chapters "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#chap-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(", "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap6#chap-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(", and "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap7#chap-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v("), we will examine the best practices for infusing Christian hope and light into these desperate pools of humanity.")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-002"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Whether they live in “slums,” “townships,” or “favelas,” the daily reality of the urban poor is much the same.")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My wife and I thought we had seen the worst conditions in southern Africa—until we and our three small children spent a year on the Operation Mobilization ship "), _c('i', [_vm._v("MV Logos ")]), _vm._v("traveling from port to port in gospel outreach. Our first stop was Mumbai. I was horrified to see poverty at a depth I had not encountered up to then. Babies had been left on the pavement under a cloth while their parents scavenged for food, or for paper and metal to resell. I had to step over the infant as I walked along the street!")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("On we went to Calcutta (now Kolkata). In one slum area, I saw that it had grown up on the bank of a drainage canal. I knew that this entire city was prone to periodic flooding of the Hooghly River that bisects it; the elevation is less than 10 meters above sea level. So I asked my guide, “What will happen to all these people when the next flood comes?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“A lot of them will die,” he answered matter-of-factly. He took it for granted. The West Bengal state, of which Kolkata is the capital, was ruled then (and for decades thereafter) by the Communist Party, and we saw its red flag with a white hammer-and-sickle everywhere. But we dared to hold an open-air evangelistic meeting in front of party headquarters, and it wasn’t long before stones began flying at us.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But even amid the hostility, we began to notice that the caste system, which has bound Indian society for centuries, was gradually starting to erode in the urban setting. Unlike in the villages, where everyone knew their place and would not dare to step out of it, city life had a way of encouraging change. The poor could at least think about attempting something outside the boundaries of their preordained status.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Since that time, India has seen a steady rise in aspirations among the Dalits (traditionally, the “untouchables” or lowest caste). They are "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("beginning to find their voice and even sway elections. Urban living has clearly been a factor in this shift.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A NEW MISSIONS EPOCH")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("But of course, cities are more than an amalgam of the poor and desperate. They are also home to the upwardly mobile, the rising middle class in many nations, as well as the power elite. When our ship docked at Singapore, we found quite the opposite of Mumbai. The city was nearly spotless, to the point that even chewing gum was banned. At that moment, there was a discussion about whether to plant fruit trees in the median strips of the various highways for beautification. Wouldn’t people try to dash across the busy lanes of traffic to steal the fruit? No, the answer came; the government would tell everyone not to do that—and they would obey!")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Here we found the ethnic Chinese majority responding rapidly to the gospel—despite living alongside a large Muslim Malay minority, and Muslim and Buddhist majorities in the surrounding nations. Churches were growing fast; it was God’s time for that city-state.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We were told that 10 percent of primary school children were Christian, 20 percent of those in secondary school, 30 percent in tertiary education, and 40 percent of all medical students. Thus, the more educated a Singaporean was, the more likely he or she was to be Christian. We eagerly joined in to support and strengthen these believers.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To this day, the growth continues. Singapore has become a strong missionary-sending country and a center for Christian leadership and ministries, not only across Asia but also beyond. It is a great example of how a key city can impact the entire world.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Onward we sailed to the ports of Australia, New Zealand, and the South Pacific. Each place brought us new insights. By the time the year was finished, Jill and I were fully aware that a new epoch was dawning. Missionary effort in the 19th and early 20th centuries had been largely rural. The famous David Livingstone, to cite just one example, had pushed into the dark heart of Africa bearing the good news. The needs "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("of the rural world were so great. And of course, we honored the legacy of those early pioneers for the gospel.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But now, we realized that the mission mindset must change. Without neglecting those in the “uttermost parts,” we must embrace the call to the world’s swarming cities.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I went to visit the teams of WEC International (the mission we joined at the end of our year aboard the "), _c('i', [_vm._v("Logos")]), _vm._v(") up in three northern provinces of Thailand, near Chiang Mai. They were earnestly working to bring Christ to the rural people there. But one day I asked the field leader, “During the course of a year, how many converts do you lose to the cities, such as Bangkok?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Oh, a lot,” he answered.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“So when are we going to plant churches in Bangkok?” I persisted.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“No,” he replied, “this is where we need to be”—even though there was a steady hemorrhage of the most effective Christians toward the urban areas.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I am glad to report that later on, further discussions and prayer led the WEC team to release workers to move to Bangkok for church planting ministry.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("HOW THEN SHALL WE MINISTER?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Such adjustments are vital for all Kingdom work, by all agencies, if we are to be effective in the world’s first urban century. We cannot keep doing things the way we’ve always done them. We must say to ourselves and to each other, “In light of urbanization—which is only going to keep growing—how then shall we minister?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the next two chapters, we shall look at:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How we think about cities—our assumptions, prejudices, and attitudes.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How "), _c('i', [_vm._v("God")]), _vm._v(" thinks about cities, as evidenced throughout his Word, in both Old and New Testaments.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Following that, we will delve into eight specific strategies for advancing the gospel in any urban setting, regardless of location. Current "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("examples will be given for each of the strategies, to establish that they are more than just theoretical.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There is an old proverb that says, “Time and tide wait for no man.” The tide of change that is now surging toward the world’s cities is not going to stop. We who serve the King of kings must accept it, understand it, and take action.")])]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 72
// module chunks = 0